import { render, staticRenderFns } from "./ProjectOfferFromRSPItem.vue?vue&type=template&id=5e36cbae&scoped=true&"
import script from "./ProjectOfferFromRSPItem.vue?vue&type=script&lang=js&"
export * from "./ProjectOfferFromRSPItem.vue?vue&type=script&lang=js&"
import style0 from "./ProjectOfferFromRSPItem.vue?vue&type=style&index=0&id=5e36cbae&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e36cbae",
  null
  
)

export default component.exports